import { FileUploadComponent } from './file-upload/file-upload.component';
import { InvoiceUploadRouterComponent } from './invoice-upload-router/invoice-upload-router.component';

export const containers = [
    FileUploadComponent,
    InvoiceUploadRouterComponent
];

export * from './file-upload/file-upload.component';
export * from './invoice-upload-router/invoice-upload-router.component';
